import React from 'react';

import { InternetBanner } from '@/ui/index';

import { ChooseTopic, SupportBanner } from '../support';

const ChooseTopicWidget = ({ data }) => {
  return (
    <>
      {data?.header && <InternetBanner bannerData={data.header} />}
      {data && <ChooseTopic pageData={data} />}
      {data?.banner && <SupportBanner item={data.banner} />}
    </>
  );
};

export default ChooseTopicWidget;
